/**
 * @desc 申请释放保证金
 */
import { UnfreezeApplyForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateAuctionUnfreezeApplyParameter = UnfreezeApplyForm

const method = 'POST'
const url = '/trade/member/unfreezeApply/auction'

export const createAuctionUnfreezeApplyApi = (
  data?: CreateAuctionUnfreezeApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createAuctionUnfreezeApplyApi.method = method
createAuctionUnfreezeApplyApi.url = url
